type Message = {
  speaker: string
  message: string
}

export function formatMessages(
  messages: Message[],
  agentName?: string,
): string {
  return messages
    .map((message) => {
      let { speaker } = message
      if (speaker === 'user') {
        speaker = 'Customer'
      } else if (speaker === 'assistant') {
        speaker = agentName ?? 'Assistant'
      }
      return `${speaker}: ${message.message}`
    })
    .join('\n')
}

export function findCustomerEmail(messages: Message[]): string | null {
  const emailRegex = /\S+@\S+\.\S+/
  const userMessageWithEmail = messages.find(
    (message) => message.speaker === 'user' && emailRegex.test(message.message),
  )
  if (userMessageWithEmail) {
    const match = userMessageWithEmail.message.match(emailRegex)
    if (match) {
      return match[0]
    }
  }
  return null
}
